import React from 'react';
import { TestCardProps } from './TestCard.types';
import {
	StyledTestCard,
	TestCardMessage,
	TestCardIndicator,
	TestCardFooter,
} from './TestCard.styles';
import { Button } from '@innovyze/stylovyze';
import { Divider } from '@mui/material';
import { useGlobalization } from '@Translations';
import {
	useSystemConnectionTest,
	useSystemConnectionTestMessage,
} from '@Hooks';

export const TestCard = ({
	status,
	buttonText,
	credentials,
	isLoading,
}: TestCardProps) => {
	const { t } = useGlobalization();

	const { triggerSystemConnection, isTestButtonDisabled } =
		useSystemConnectionTest(isLoading, credentials);
	const message = useSystemConnectionTestMessage(status);

	const handleOnClickTestButton = (): void => {
		triggerSystemConnection();
	};

	return (
		<StyledTestCard>
			<TestCardMessage>
				<TestCardIndicator status={status} data-cy="testIndicator" />
				<p data-cy="testMessage">{message}</p>
			</TestCardMessage>
			<div>
				<Divider />
				<TestCardFooter>
					<p>
						{t(
							'Username, Password, and Connection String are required for testing the connection',
						)}
					</p>
					<Button
						data-cy="testConnectionButton"
						variant="outlined"
						color={isTestButtonDisabled ? 'secondary' : 'primary'}
						onClick={handleOnClickTestButton}
						disabled={isTestButtonDisabled}>
						{buttonText}
					</Button>
				</TestCardFooter>
			</div>
		</StyledTestCard>
	);
};
